import { render, staticRenderFns } from "./DelService.vue?vue&type=template&id=bb7ffa44&scoped=true"
import script from "./DelService.vue?vue&type=script&lang=js"
export * from "./DelService.vue?vue&type=script&lang=js"
import style0 from "./DelService.vue?vue&type=style&index=0&id=bb7ffa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7ffa44",
  null
  
)

export default component.exports